// import "../styles/FuturePlans.css";

// export default function FuturePlans() {
//   return (
//     <section className="future-section">

//       <div className="container">

//         {/* HEADER */}
//         <div className="future-header">

//           <h2>Future Plans</h2>

//           <p>
//             Strategic expansion roadmap focused on capacity growth,
//             advanced machinery, and global manufacturing excellence.
//           </p>

//         </div>

//         {/* GRID */}
//         <div className="future-grid">

//           <div className="future-card">
//             🏭 Setting up new unit – 80,000 sq.ft (2 Acres) 
//           </div>

//           <div className="future-card">
//             🔥 New Heat Exchanger Lines – 3 Lines (Ordered)
//           </div>

//           <div className="future-card">
//             🔧 New Tubing Line – Machinery Received
//           </div>

//           {/* <div className="future-card">
//             ⚙ New Commercial Production Line – Ordered
//           </div> */}

//           <div className="future-card">
//             🏋 New Press Line – Yangli (Ordered)
//           </div>

//           <div className="future-card">
//             🌀 New Turret System – 40 Station, 5 Axis (Yangli Ordered)
//           </div>

//           <div className="future-card full-width">
//             💡 New Laser Cutting Line – Bodor 3KW (Cuts up to 40mm thickness)
//           </div>

//         </div>

//       </div>

//     </section>
//   );
// }


















import "../styles/FuturePlans.css";

export default function FuturePlans() {
  return (
    <section className="future-section">

      <div className="container">

        {/* HEADER */}
        <div className="future-header">

          <h2>Future Plans</h2>

          <p>
            Strategic expansion roadmap focused on capacity growth,
            advanced machinery, and global manufacturing excellence.
          </p>

        </div>

        {/* GRID */}
        <div className="future-grid">

          <div className="future-card">
            <span className="future-icon">🏭</span>
            <p>Setting up new unit – 80,000 sq.ft (2 Acres)</p>
          </div>

          <div className="future-card">
            <span className="future-icon">🔥</span>
            <p>New Heat Exchanger Lines – 3 Lines (Ordered)</p>
          </div>

          <div className="future-card">
            <span className="future-icon">🔧</span>
            <p>New Tubing Line – Machinery Received</p>
          </div>

          <div className="future-card">
            <span className="future-icon">🏋</span>
            <p>New Press Line – Yangli (Ordered)</p>
          </div>

          <div className="future-card">
            <span className="future-icon">🌀</span>
            <p>New Turret System – 40 Station, 5 Axis (Yangli Ordered)</p>
          </div>

          <div className="future-card">
            <span className="future-icon">💡</span>
            <p>New Laser Cutting Line – Bodor 3KW (Cuts up to 40mm thickness)</p>
          </div>

        </div>

      </div>

    </section>
  );
}